export default __webpack_public_path__ + "static/media/eightplus.b4ccebca.png";